"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_select_1 = require("react-select");
var get_1 = __importDefault(require("lodash/get"));
var RegionElement_1 = __importDefault(require("@r1-frontend/city-select/components/RegionElement"));
var TopCities_1 = __importDefault(require("@r1-frontend/city-select/components/TopCities"));
var getOptionsBySatellites_1 = require("@r1-frontend/city-select/helpers/getOptionsBySatellites");
var useColumnsByRegionLetters_1 = require("@r1-frontend/city-select/hooks/useColumnsByRegionLetters");
var button_1 = __importDefault(require("@r1-frontend/ui-react/components/buttons/button"));
var Throbber_1 = __importDefault(require("@r1-frontend/ui-react/components/loaders/Throbber"));
var arrows_1 = require("@r1-frontend/ui-react/components/svg/arrows");
var heading_1 = require("@r1-frontend/ui-react/components/typography/heading");
var ST = __importStar(require("./styled"));
var noOptionsMessage = function (message, field) { return function (inputValue) {
    return inputValue === '' || ((0, get_1.default)(field, 'label', '') === inputValue) ? message : 'Не найдено';
}; };
var filterConfig = {
    ignoreCase: true,
    ignoreAccents: true,
    trim: true,
    matchFrom: 'start',
};
var CitySelect = function (_a) {
    var regions = _a.regions, topCities = _a.topCities, citiesSatellites = _a.citiesSatellites, selectedRegion = _a.selectedRegion, onRegionSelect = _a.onRegionSelect, onCitySelect = _a.onCitySelect, city = _a.city;
    var citiesOptions = (0, react_1.useMemo)(function () { return (0, getOptionsBySatellites_1.getOptionsBySatellites)(citiesSatellites); }, [citiesSatellites]);
    var lettersByColumns = (0, useColumnsByRegionLetters_1.useColumnsByRegionLetters)({ regions: regions, topCities: topCities });
    var onChangeCity = function (selectedCityOption) {
        var label = selectedCityOption.label, value = selectedCityOption.value, provider_id = selectedCityOption.provider_id;
        onCitySelect({ name: "".concat(label), domain: value, provider_id: provider_id });
    };
    return (<ST.Container>
            <ST.GlobalStyle $active/>
            <ST.ContentWrapper>
                <button_1.default size={'medium'} bType={'ghost'} Icon={<arrows_1.ArrowLeft size={24}/>} onClick={function () { return onCitySelect(); }}>
                    Назад
                </button_1.default>

                <heading_1.H2 $withIndent={false}>Выберите город</heading_1.H2>

                {(!!lettersByColumns.length && !!topCities.length && !!citiesSatellites.length)
            ? <>
                        <ST.DropDown value={city} onChange={onChangeCity} options={citiesOptions} placeholder={'Ваш город'} noOptionsMessage={noOptionsMessage('Введите город', city)} isSearchable={true} filterOption={(0, react_select_1.createFilter)(filterConfig)}/>
                        <ST.ColumnsWrapper>
                            {lettersByColumns.map(function (lettersColumn, columnIndex) {
                    var columnLetters = Object.keys(lettersColumn);
                    return (<ST.Column key={columnIndex}>
                                        {columnIndex === 0 && (<TopCities_1.default topCities={topCities} onCitySelect={onCitySelect}/>)}
                                        {columnLetters.map(function (letter) { return (<ST.RegionsWrapper key={letter} data-test='regions-wrap'>
                                                <ST.RegionsLetter data-test='letter'>{letter}</ST.RegionsLetter>
                                                {lettersColumn[letter].map(function (region) { return (<RegionElement_1.default key={region.region_id} isRegionOpen={region.region_id === (selectedRegion === null || selectedRegion === void 0 ? void 0 : selectedRegion.region_id)} region={region} onRegionSelect={onRegionSelect} onCitySelect={onCitySelect}/>); })}
                                            </ST.RegionsWrapper>); })}
                                    </ST.Column>);
                })}
                        </ST.ColumnsWrapper>
                    </>
            : <Throbber_1.default />}
            </ST.ContentWrapper>
        </ST.Container>);
};
exports.default = CitySelect;
